import { Box, Button, Drawer, Grid, Typography } from "@mui/material"
import { ArrowBack } from "../../../../components/arrowBack"
import { ReincidencesProps } from "./types"
import { useStyles } from "./styles"
import { BaseInput } from "../../../../components"
import { useTranslation } from "react-i18next"
import { useEffect, useMemo, useState } from "react"
import { IsBlur, onChange } from "../../../../utils/types/generals"
import { useQuestionnaireContext } from "../../pages/detail/contextProvider"

const defaultRecurrence = {
    reincidence: '2',
    block: '1'
}
const Reincidence = (props: ReincidencesProps) => {
    const { t } = useTranslation()
    const styles = useStyles()
    const { setModal, closeModal } = useQuestionnaireContext()
    const defaultData = useMemo(() => props.data ?? defaultRecurrence, [props.data])
    const [reincidences, setReincidences] = useState(defaultData)
    const onChange: onChange = ({ target: { name, value }, }, blur) => {
        setReincidences((prev) => ({ ...prev, [name]: value }))
        if ((blur as IsBlur).blur && (!value || value < 2)) {
            setReincidences(prev => ({ ...prev, [name]: defaultRecurrence[name] }))
        }
    }

    const returnConfig = () => {
        setModal(prev => ({
            ...prev,
            open: true,
            title: t('general.goBackToConfig'),
            description: t('general.changeWillBeDiscarded'),
            confirm: () => {
                if (props.close) {
                    returnConfig()
                    props.close({
                        data: defaultData
                    })
                    setReincidences(defaultData)
                }
                closeModal()
            },
            cancel: () => {
                closeModal()
            }
        }))
    }
    useEffect(() => {
        setReincidences(props.data ?? defaultRecurrence)
    }, [props.data])
    return (
        <Drawer {...props} anchor="right">
            <Box sx={styles.container}>
                <ArrowBack
                    arrowProps={{
                        onClick: () => {
                            returnConfig()
                        },
                        sx: {
                            padding: '10px 20px 10px 0px',
                        }
                    }}
                    label={t('general.returnQuestionnaireConfig')}
                    boxProps={{
                        sx: {
                            marginLeft: '-20px'
                        }
                    }}
                />

                <Typography variant="title_main" fontWeight='500'>{t('Questionarie.recurrenceTitle')}</Typography>

                <Typography variant="subtitle" >{t('Questionarie.recurrenceSub')}</Typography>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="subtitle" fontWeight='500' >{t('Questionarie.maxReincidence')}</Typography>

                        <BaseInput
                            name="reincidence"
                            onChange={onChange}
                            value={{ reincidence: { label: '', type: 'number', value: reincidences.reincidence, } }}
                            type="number"
                            sx={styles.maxInput}
                            min={1}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="subtitle" fontWeight='500'>{t('Questionarie.blocks')}</Typography>

                        <BaseInput
                            name="block"
                            onChange={onChange}
                            value={{ block: { label: '', type: 'number', value: reincidences.block, } }}
                            type="number"
                            sx={styles.maxInput}
                            min={1}
                        />
                    </Grid>
                </Grid>

                <Box sx={styles.footer}>
                    <Button onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        if (props.saveReincidence) { props.saveReincidence({ data: reincidences }) }
                    }} variant="contained">{t('general.save')}</Button>

                    <Button onClick={() => { returnConfig() }}>{t('general.cancel')}</Button>
                </Box>
            </Box>
        </Drawer>
    )
}

export { Reincidence }